import { useParams } from 'react-router-dom';
import { useGetFormDraftQuery } from '../Services/apiSlice';

const useFormDraft = () => {
  const { formId } = useParams();
  return useGetFormDraftQuery(formId);
};

export default useFormDraft;
